import {inject} from '@angular/core';
import {FormGroupDirective, NgForm} from '@angular/forms';

// Get the parent form for reactive forms or template-driven forms.
// only usable in a constructor context, like inject()
export function injectParentForm(): FormGroupDirective | NgForm | null {
  // FormGroupDirective is parent formGroup for reactive forms
  // NgForm is parent ngForm for template-driven forms
  return inject(FormGroupDirective, {
    optional: true,
  }) || inject(NgForm, {
    optional: true,
  });
}

// Get the parent reactive form and template-driven form.
// only usable in a constructor context, like inject()
export function injectParentForms(): Array<FormGroupDirective | NgForm> {
  const reactiveForm = inject(FormGroupDirective, {
    optional: true,
  });
  const templateForm = inject(NgForm, {
    optional: true,
  });
  const forms: Array<FormGroupDirective | NgForm> = [];
  if (reactiveForm) {
    forms.push(reactiveForm);
  }
  if (templateForm) {
    forms.push(templateForm);
  }
  return forms;
}
